import React from 'react';
import { bem } from '../../../core/design/bem';
import SquareImage from '../../SquareImage';
import { ActionItem, ContactItem, InfoProps } from '../types';
import { ContactVariants } from '../variants';
import Actions from './Actions';
import ItemInfos from './ItemInfos';
import './Contact.scss';

const css = bem('Contact');

export type ContactBlockProps = {
  item: ContactItem;
  variant: ContactVariants;
  actions: ActionItem[];
  infos: InfoProps[];
};

const Contact = ({ item, variant, actions, infos }: ContactBlockProps): JSX.Element => {
  return (
    <div className={css({ variant })}>
      <div className={css('Wrapper')}>
        <div className={css('Profile')}>
          <div className={css('Thumbnail')}>
            <SquareImage src={item.thumbnail} imageSize={200} />
          </div>
          <ItemInfos item={item} infos={infos} />
        </div>
        <div className={css('Actions')}>
          <Actions item={item} actions={actions} />
        </div>
      </div>
    </div>
  );
};

export default Contact;
